var React = require('react');

function Am (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_7421_17811)","key":0},[React.createElement("path",{"d":"M89.4857 0H0V69H89.4857L120 33.12L89.4857 0Z","fill":"#FEF200","key":0}),React.createElement("path",{"d":"M40.7692 47.522H24.1993L21.0491 57H11L28.074 11H36.8315L54 57H43.9509L40.7692 47.522ZM26.7509 39.8448H38.2176L32.4527 22.6264L26.7509 39.8448Z","fill":"white","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_7421_17811"},React.createElement("rect",{"width":"120","height":"69","fill":"white"})))]);
}

Am.defaultProps = {"width":"120","height":"69","viewBox":"0 0 120 69","fill":"none"};

module.exports = Am;

Am.default = Am;
